var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMessageCircleFat = function SvgMessageCircleFat(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 4.31251C7.87629 4.80746 7.76065 5.29572 7.5375 5.73751C7.27291 6.26692 6.86616 6.7122 6.36279 7.02349C5.85943 7.33478 5.27934 7.49978 4.6875 7.50001C4.19255 7.5013 3.70429 7.38566 3.2625 7.16251L1.125 7.87501L1.8375 5.73751C1.61435 5.29572 1.49871 4.80746 1.5 4.31251C1.50023 3.72067 1.66523 3.14058 1.97652 2.63722C2.28781 2.13385 2.7331 1.7271 3.2625 1.46251C3.70429 1.23936 4.19255 1.12372 4.6875 1.12501H4.875C5.65663 1.16813 6.39489 1.49805 6.94843 2.05158C7.50196 2.60512 7.83188 3.34338 7.875 4.12501V4.31251Z",
    stroke: "#6280DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessageCircleFat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message-circle-fat.b2ea818b.svg";
export { ForwardRef as ReactComponent };